import { createSlice } from "@reduxjs/toolkit";
import { fetchUserPaymentHistory, fetchUserPaymentReportTableColumnNames, fetchUserWithTotalPayment } from "./thunk";

const initialState = {
  tableColumnNames: [],
  userPayments: [],
  paymentHistory: [],
  loading: false,
  headerLoading: false,
  paymentHistoryLoading: false,
  error: null,
};

const userPaymentsSlice = createSlice({
  name: "userPayments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Chat Report Table Column Names
    .addCase(fetchUserPaymentReportTableColumnNames.pending, (state) => {
        state.headerLoading = true;
        state.error = null;
    })
    .addCase(fetchUserPaymentReportTableColumnNames.fulfilled, (state, action) => {
        state.headerLoading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchUserPaymentReportTableColumnNames.rejected, (state, action) => {
        state.headerLoading = false;
        state.error = action.payload;
    })


    .addCase(fetchUserWithTotalPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchUserWithTotalPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.userPayments = action.payload;
    })
    .addCase(fetchUserWithTotalPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchUserPaymentHistory.pending, (state) => {
        state.paymentHistoryLoading = true;
        state.error = null;
    })
    .addCase(fetchUserPaymentHistory.fulfilled, (state, action) => {
        state.paymentHistoryLoading = false;
        state.paymentHistory = action.payload;
    })
    .addCase(fetchUserPaymentHistory.rejected, (state, action) => {
        state.paymentHistoryLoading = false;
        state.error = action.payload;
    })
  },
});

export default userPaymentsSlice.reducer;
